import React from 'react';
import PropTypes from 'prop-types';

import { CustomPropTypes } from '@admin-shared/config';
// Sections
import { BasicBlockSection } from '@sections/components';

const Main = ({ sections, breakpoints }) => {
  const components = {
    'basic': BasicBlockSection
  };

  return (
    <div>
      {sections.map((section) => {
        const Component = components[section.type];
        return (
          <Component
            key={section.id}
            {...section}
            breakpoints={breakpoints}
          />
        );
      })}
    </div>
  );
};

Main.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: CustomPropTypes.integerRequired.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  breakpoints: PropTypes.shape({
    tablet: PropTypes.string.isRequired,
    desktop: PropTypes.string.isRequired
  }).isRequired
};

export default Main;
